import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-journey-list-template-interaction-card',
  templateUrl: './list-template-interaction-card.component.html',
  styleUrls: ['./list-template-interaction-card.component.scss']
})
export class LearningJourneyListTemplateInteractionCardComponent {
  @Input() type: string;
  @Input() title: string;
  @Input() completed: boolean;
  @Input() passed: boolean;
}
